module.exports = __webpack_public_path__ + "static/media/car_history.34cf1f57.svg";